/**
 * DevExtreme logical operators for filter expressions.
 * Used to combine multiple filter terms in DevExtreme-style filter arrays.
 */
export const logicalOperator = Object.freeze({
    AND: "and",
    OR: "or"
});
